import app from "../data/base";

async function loadRelatori() {
  console.log('loadRelatori')
  try {
    const response = await app.methods.callserver('api/speaker', 'GET', null, null, true);
    return await response.json();
  } catch (e) {
    console.error(e);
    throw e;
  }
}

async function loadRelatoriGruppo(idGroup) {
  console.log('loadRelatoriGruppo')
  try {
    const response = await app.methods.callserver('api/speaker/group/' + idGroup, 'GET', null, null, true);
    return await response.json();
  } catch (e) {
    console.error(e);
    throw e;
  }
}

async function saveRelatore(inputobject) {
  console.log(inputobject);
  const body = `${JSON.stringify(inputobject)}`;
  try {
    const response = await app.methods.callserver('api/speaker', 'POST', null, body, true);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

async function updateRelatore(inputobject) {
  console.log(inputobject);
  const body = `${JSON.stringify(inputobject)}`;
  try {
    const response = await app.methods.callserver('api/speaker', 'PUT', null, body, true);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

async function deleteRelatore(idrelatore) {
  try{
      console.log(idrelatore);
      const response = await app.methods.callserver('api/speaker/' + idrelatore,'DELETE',false, null);
      console.log(response)
      if(response.status=='201' || response.status=='200'){
          return true;
      }else{
          return false;
      }

  }catch(err){
      console.log('Error during saveUtente');
      console.log(err);
      return false;
  }
}


const getList = async () => {
  try {
    const response = await app.methods.callserver('api/session/speakers', 'GET', null, null, true);
    const speakers = await response.json();
    return speakers;

  } catch (err) {
    console.log('[api/session/speakers] Error on getList');
    console.log(err);
    throw err;
  }
}



export const speaker = {
  methods: {
    getList,
    loadRelatori,
    loadRelatoriGruppo,
    deleteRelatore,
    saveRelatore,
    updateRelatore
  }
}
